<template>
  <div
    class="layer-container"
    @drop="drop"
    @dragover="dragOver"
    :group-name="groupName"
  >
    <Shape
      :layer="layer"
      :key="layer.id"
      v-for="layer in layers"
    >
      <Layer :layer="layer" />
    </Shape>
  </div>
</template>
<script>
import Shape from './shape'
import Layer from '../layer'
export default {
  name: 'ICLayerContainer',
  components: {
    Shape,
    Layer
  },
  inject: [
    'addLayer',
    'removeLayer'
  ],
  props: {
    pid: {
      type: [Number, String],
      default: () => undefined
    },
    layers: {
      type: Array,
      default: () => []
    },
    groupName: {
      type: String,
      default: () => 'container'
    }
  },
  methods: {
    drop (event) {
      event.preventDefault()
      event.stopPropagation()
      // 容器组件的额外处理
      const { pageX, pageY, offsetX, offsetY } = event
      console.log('page: (%s, %s)', pageX, pageY)
      console.log('offset: (%s, %s)', offsetX, offsetY)
      const material = JSON.parse(event.dataTransfer.getData('material'))
      this.addLayer({
        ...material,
        pid: this.pid,
        position: {
          x: offsetX,
          y: offsetY
        }
      })
    },
    dragOver (event) {
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
</script>
